'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'building-columns';
var width = 512;
var height = 512;
var aliases = ["bank","institution","museum","university"];
var unicode = 'f19c';
var svgPathData = 'M269.2 11.9c-8-5.2-18.3-5.2-26.3 0l-232 152C2 169.7-2 180.7 1 190.9S13.4 208 24 208l40 0 0 160-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160 40 0c10.6 0 20-7 23-17.1s-1-21.1-9.8-26.9l-232-152zM176 368l-64 0 0-160 64 0 0 160zm112 0l-64 0 0-160 64 0 0 160zm112 0l-64 0 0-160 64 0 0 160zM228.3 160L104.4 160 256 60.7 407.6 160 283.7 160c2.7-4.7 4.3-10.2 4.3-16 0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBuildingColumns = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;